<template>
    <div class="row">
        <div class="text-center col-12">
         <a :href="'/'+loc.locale" v-for="loc in l">
            <span class="flag">{{ getFlagEmoji(loc.locale) }}</span>
         </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'locale',
        data () {
            return {
                l: []
            }
        },
        mounted () {
            this.fetchLocales()
        },
        methods: {
            fetchLocales() {
                this.$http.get(api + 'api/v1/locales').then(response => {
                    this.l = response.body.result;
                })
            },
            getFlagEmoji (countryCode) {

                if (countryCode == "en"){
                    countryCode = "gb"
                }

                const codePoints = countryCode
                    .toUpperCase()
                    .split('')
                    .map((char) => 127397 + char.charCodeAt(0))
                return String.fromCodePoint(...codePoints)
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flag {
    font-size: 54px;
    padding: 5px;
    text-align: center;
}
.text-center {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/widget/locale.vue